'use client';

import { c as _c } from "react/compiler-runtime";
import type { GroupMentoringProductDTO, IndividualMentoringProductDTO, ProjectMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { cn } from '@algoacademy/design-system/shared/cn';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { MentoringOfferForm } from '../../_forms/MentoringOfferForm';
import type { MentoringDiscountDraft } from '../DiscountControls';
type StaffMentoringOfferPanelProps = {
  mentoringProduct: GroupMentoringProductDTO | IndividualMentoringProductDTO | ProjectMentoringProductDTO;
  discountDraft: MentoringDiscountDraft;
  onDiscountChange: (nextDraft: MentoringDiscountDraft) => void;
  goalPage?: boolean;
};
export function StaffMentoringOfferPanel(t0) {
  const $ = _c(9);
  const {
    mentoringProduct,
    discountDraft,
    onDiscountChange,
    goalPage: t1
  } = t0;
  const goalPage = t1 === undefined ? false : t1;
  const t2 = goalPage && "dark";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("rounded-lg", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== discountDraft || $[3] !== mentoringProduct || $[4] !== onDiscountChange) {
    t4 = <MentoringOfferForm mentoringProduct={mentoringProduct} discountDraft={discountDraft} onDiscountChange={onDiscountChange} />;
    $[2] = discountDraft;
    $[3] = mentoringProduct;
    $[4] = onDiscountChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <LightCard className={t3}>{t4}</LightCard>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}